module.exports = __webpack_public_path__ + "img/banner.cad27752.jpg";